<div class="l-aside" :class="className()" data-toggle-aside>
	<button type="button" v-toggle="{className: 'is-open', selector: '[data-toggle-aside]'}" class="l-aside-btn-close rwd-over-small rwd-under-medium" :title="$t('vm.components.layout.aside.close.title')">
		<svg width="1em" class="svg-block" viewBox="0 0 320 512" aria-hidden="true">
			<use xlink:href="@Assets/svg/symbol-defs.svg#times"/>
		</svg>
		<span class="sr-only">{{$t('vm.components.layout.aside.close.label')}}</span>
	</button>
    <slot/>
</div>
